export const INTEGRATION = {
  gatewayUrl: 'https://int-api.resi.io',
  ldClientSideId: '6736363f5778ca0863fba41a',
  resiStorageKey: 'int-sites-resi-io',
  sitesClientUrl: 'https://int-sites.resi.io/',
  sitesUrl: 'https://int-sites-boot.resi.io',
  webplayerEnvAttribute: 'int',
  webplayerLoader: 'https://control.resi.io/webplayer/loader-test.min.js',
  webplayerPageScript: 'https://control.resi.io/webplayer/page-test.min.js',
};
export const PRODUCTION = {
  gatewayUrl: 'https://api.resi.io',
  ldClientSideId: '6736363f5778ca0863fba41b',
  resiStorageKey: 'sites-resi-io',
  sitesClientUrl: 'https://sites.resi.io/',
  sitesUrl: 'https://sites-boot.resi.io',
  webplayerEnvAttribute: 'prod',
  webplayerLoader: 'https://control.resi.io/webplayer/loader.min.js',
  webplayerPageScript: 'https://control.resi.io/webplayer/page.min.js',
};

export const SENTRY_ENV_LOCAL_DEV = 'local-dev';
export const SENTRY_ENV_INT = 'integration';
export const SENTRY_ENV_PROD = 'production';

export const ONE_HUNDRED_PERCENT = 1.0;
export const TWENTY_PERCENT = 0.2;

let playerHtml = '';
let playerPagesScript = '';
let webplayerEnvAttribute = '';

switch (true) {
  case /[-_a-zA-Z0-9]*.resi-sites.pages.dev/.test(window.location.host):
  case /int-sites.resi.io/.test(window.location.host):
  case new RegExp('localhost:port'.replace('port', `${process.env.VITE_LOCAL_HOST_PORT}`)).test(window.location.host):
  case new RegExp('127.0.0.1:port'.replace('port', `${process.env.VITE_LOCAL_HOST_PORT}`)).test(window.location.host):
    playerHtml = '/video-test.html';
    playerPagesScript = 'https://control.resi.io/webplayer/page-test.min.js';
    webplayerEnvAttribute = 'int';
    break;
  default:
    playerHtml = '/video.html';
    playerPagesScript = 'https://control.resi.io/webplayer/page.min.js';
    webplayerEnvAttribute = 'prod';
    break;
}

export { playerHtml, playerPagesScript, webplayerEnvAttribute };

export const WEBPLAYER_ORIGIN = 'https://control.resi.io';
export const WEBPLAYER_URL = `${WEBPLAYER_ORIGIN}/webplayer`;
export const WEBPLAYER_SOURCE = `${WEBPLAYER_URL}${playerHtml}`;
